import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
} from 'chart.js';
import { currencyFormatter } from '../../../../core';

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);

ChartJS.defaults.plugins.legend.labels.boxHeight = 4;
ChartJS.defaults.plugins.legend.labels.boxWidth = 12;
ChartJS.overrides.bar.responsive = false;

export const options = {
  responsive: true,
  plugins: {
    datalabels: {
      formatter: (value, ctx) => {
        const total = ctx.dataset.data.reduce((acc, item) => (acc += item), 0);
        return `${currencyFormatter(value)}\n${((value / total) * 100).toFixed(
          2
        )}%`;
      },
      font: {
        size: 12,
        weight: 700
      },
      textAlign: 'center' as const
    },
    legend: {
      position: 'bottom' as const,
      labels: {
        font: {
          size: 12,
          weight: '500',
          borderRadius: 20
        }
      }
    },
    title: {
      display: false
    }
  }
};
